NameLinks = new (function () {
  this.setSelects = () => {
    let wrapper = $(".manage-name-links");

    let studentNameLinkSelect = document.querySelector("#name-link-student-edit");
    if (studentNameLinkSelect) {
      let { id, name } = studentNameLinkSelect.dataset;
      if (id && name) studentNameLinkSelect.append(new Option(name, id, true, true));
    }

    $(studentNameLinkSelect).select2({
      placeholder: "- Select Student -",
      ajax: { dataType: "json", url: "/student_entities/autocomplete", delay: 250 },
    });

    $("#name-link-user-edit").select2({
      placeholder: "- Select Teacher -",
    });

    $("#name-link-student-select", wrapper).select2({
      placeholder: "- Filter by student name -",
      ajax: { dataType: "json", url: "/student_entities/autocomplete", delay: 250 },
    });

    $("#name-link-teacher-select", wrapper).select2({
      placeholder: "- Filter by teacher name -",
      ajax: { dataType: "json", url: "/teacher_entities/autocomplete", delay: 250 },
    });
  };

  this.bindEvents = () => {
    $("#name-link-name-select").val("");
  };
})();
